module.exports = __webpack_public_path__ + "static/img/my-class-bg1.f55d96de.png";